<template>
    <GZ-ModalMainTmpl>
        <span slot="title">Добавить комментарий</span>
            <textarea
                slot="content"
                cols="30" 
                rows="10" 
                placeholder="Добавьте комментарий" 
                v-model="note"
            ></textarea>
            <GZ-BaseButton 
                slot="actions"
                value="добавить" 
                icon="icon-plus"
                class="gz-button_default gz-button_save"
                @click="saveNote"
            />
    </GZ-ModalMainTmpl>
</template>

<script>
export default {
    name: 'AddressNotificationAddModal',

    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            dataObj: {},
            note: '',
            loading: false
        }
    },
    mounted() {
        this.getObject()
    },
    methods: {
        getObject() {
            this.$axios({
                method: 'get',
                url: this.data.url + '/' + this.data.id
            })
            .then(response => {
                this.dataObj = response.data
                this.note = response.data.data.attributes.notes
            })
            .catch(err => {
                console.log('Ошибка получения данных об объекте для записей: ', err)
            })
        },
        saveNote() {
            this.dataObj.data.attributes.notes = this.note

            this.$axios({
                method: 'patch',
                url: this.data.url + '/' + this.data.id,
                data: this.dataObj
            })
            .then(response => {
                this.$store.dispatch('notificationStaticMessage', response.data.data.attributes.notes)
                this.$store.dispatch('modalClose')
            })
            .catch(err => {
                console.log('Ошибка отправки объекта при добавлении комментария: ', err)
            })
        }
    }
}
</script>